import type {z} from "zod";

import {CreateSupplierBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {supplierFieldLabelIds} from "../../../messages/suppliers.messages";

const company = CreateSupplierBody.shape.company.shape;
const profile = company.partyProfile.shape;
const phone = profile.phone.shape;

export const createSupplierFormSchema = zod.object({
  companyId: requiredStringSchema(company.companyId, supplierFieldLabelIds.companyId),
  companyName: requiredStringSchema(company.companyName, supplierFieldLabelIds.companyName),
  address: requiredStringSchema(profile.address.shape.address, supplierFieldLabelIds.address),
  country: profile.country,
  phoneNumber: phone.nationalNumber,
  phonePrefix: phone.regionCode,
  websiteUrl: profile.websiteUrl,
  logoUrl: CreateSupplierBody.shape.logoUrl,
  status: CreateSupplierBody.shape.status,
  roles: CreateSupplierBody.shape.roles,
  standardization: CreateSupplierBody.shape.standardization,
  deliveryTimeDays: CreateSupplierBody.shape.deliveryTimeDays,
  paymentTimeDays: CreateSupplierBody.shape.paymentTimeDays,
});
export type CreateSupplierFormPayload = z.output<typeof createSupplierFormSchema>;

export const draftCreateSupplierFormSchema = createSupplierFormSchema.partial();
export type DraftCreateSupplierFormPayload = z.output<typeof draftCreateSupplierFormSchema>;
